import {Component, HostBinding, inject, Input} from '@angular/core';
import {NavigationService} from 'app/services/navigation.service';
import {AppService} from 'app/services/app.service';
import {HelperService} from 'app/services/helper.service';

@Component({
  template: ''
})
export abstract class BlockElementAbstractComponent<T> {
  @Input() public blockElement: T | any = null;
  @Input() public rootElement = false;

  ignoreSettings: string[] = [];

  navigationService = inject(NavigationService);

  @HostBinding('class')
  get classes() {
    return this.blockElement?.settings ? this.blockElement?.settings?.getClasses(this.ignoreSettings) : [];
  }

  actionClick() {
    console.log('el', this.blockElement);
    if (this.blockElement.action) {
      if (this.blockElement.method) {
        this.blockElement.method(this.blockElement);
      } else if (this.blockElement.action.data) {
        this.navigationService.processActionData(this.blockElement.action.data, this.blockElement.action.page);
      } else if (this.blockElement.action.link) {
        HelperService.openLink(this.blockElement.action.link);
      }
    }

  }
}
